import { apiUrl } from '../runtime'

// Browser replacement for createEvent: POST to core's backend with the shared session cookie.
// Mirrors @/app/actions/events#createEvent.
export async function createEvent(data: {
  question: string
  description?: string
  categories?: string[]
  closes_at?: string
  labels: string[]
  restricted_user_ids?: number[]
  is_inside_joke?: boolean
  interaction_allowance?: string
}): Promise<{ id?: number; error?: string }> {
  try {
    const res = await fetch(apiUrl('/api/events'), {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    const json = await res.json().catch(() => ({}))
    if (!res.ok) return { error: json.detail ?? 'Failed to create event' }
    return { id: json.id }
  } catch {
    return { error: 'Failed to create event' }
  }
}
